import { useApolloClient } from "@apollo/client";
import Pagination from "@mostrans/web-components/components/base/Pagination";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import { Grid, Icon, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import ListItemButton from "@mui/material/ListItemButton";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { UpdateStatusOpportunity } from "../../../GQL/mutations";
import { GetOpportunityByID } from "../../../GQL/queries";
import {
    valueInputOpportunity,
    valueSearchJobStatusAtoms,
    valueSearchJobsDivisionAtoms,
    valueSearchJobsNameAtoms,
    valueUseRef,
} from "../../../shared/atoms/getValueInputAtoms";
import ModalDetailOpportunity from "./DetailJobs/ModalDetailOpportunity";

function CardJobs(props) {
    const client = useApolloClient();
    const { allOpportunity, fetchAllOpportunity } = props;
    const [openModalDetailJob, setOpenModalDetailJob] = useState(false);
    const { showConfirmationModal } = useConfirmationModal();
    const [dataDetailJob, setDataDetailJob] = useState([]);
    const valueSearchByJobsName = useRecoilValue(valueSearchJobsNameAtoms);
    const filterValueStatusJobs = useRecoilValue(valueSearchJobStatusAtoms);
    const valueSearchByDivision = useRecoilValue(valueSearchJobsDivisionAtoms);
    const resetInputOpportunity = useResetRecoilState(valueInputOpportunity);
    const resetSearchValueJobsName = useResetRecoilState(
        valueSearchJobsNameAtoms
    );
    const resetSearchValueJobStatus = useResetRecoilState(
        valueSearchJobStatusAtoms
    );
    const resetSearchValueJobsDivision = useResetRecoilState(
        valueSearchJobsDivisionAtoms
    );
    const refBox = useRecoilValue(valueUseRef);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const goToTop = () => {
        refBox?.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        resetSearchValueJobsName();
        resetSearchValueJobStatus();
        resetSearchValueJobsDivision();
        fetchAllOpportunity();
    }, [client]);

    const handleCloseJobModalDetail = () => {
        setOpenModalDetailJob(false);
        resetInputOpportunity();
    };

    // Filter Jobs
    const filterJobs = () => {
        const filteredJobsList = allOpportunity?.filter((jobs) => {
            return filterValueStatusJobs === null
                ? jobs.title
                    .toLowerCase()
                    .match(valueSearchByJobsName?.toLowerCase()) &&
                jobs.Division.division
                    .toLowerCase()
                    .match(valueSearchByDivision?.toLowerCase())
                : jobs.title
                    .toLowerCase()
                    .match(valueSearchByJobsName?.toLowerCase()) &&
                jobs.Division.division
                    .toLowerCase()
                    .match(valueSearchByDivision?.toLowerCase()) &&
                jobs.is_open === filterValueStatusJobs;
        });
        return filteredJobsList;
    };

    useEffect(() => {
        setCurrentPage(0);
    }, [valueSearchByJobsName, valueSearchByDivision, filterValueStatusJobs]);

    // Update Status Jobs
    const UpdateJobStatus = async (opportunity) => {
        const show = await showConfirmationModal({
            contentText: "Are you sure to update job status?",
        });

        const paramUpdate = {
            id: opportunity.id,
            is_open: opportunity.is_open === true ? false : true,
        };

        if (show.isConfirmed) {
            try {
                const responsUpdate = await UpdateStatusOpportunity(
                    client,
                    paramUpdate
                );

                if (
                    responsUpdate.data.updateStatusOpportunity.errMsg === "OK"
                ) {
                    toast.success("Job Updated", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    fetchAllOpportunity();
                } else {
                    toast.error("Job Update Failed", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } catch (error) {
                console.log(error, "Error Update Status Job");
            }
        }

        if (show.isDenied) {
            toast.error("Canceled", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    //  show detail modal job
    const onShowDetailModalJob = async (dataJobs) => {
        const opportunity = await GetOpportunityByID(client, dataJobs.id);
        await setDataDetailJob(opportunity);
        setOpenModalDetailJob(true);
    };

    const changePage = (page) => {
        setCurrentPage(page);
        goToTop();
    };

    const filteredJobs = filterJobs();


    return (
        <>
            <ToastContainer />
            <ModalDetailOpportunity
                isOpen={openModalDetailJob}
                onClose={handleCloseJobModalDetail}
                dataDetail={dataDetailJob}
                setDataDetailJob={setDataDetailJob}
                fecthOpportunity={fetchAllOpportunity}
            />

            {filteredJobs.length > 0 ? (
                filteredJobs
                    ?.slice(
                        currentPage * rowsPerPage,
                        (currentPage + 1) * rowsPerPage
                    )
                    .map((opportunity) => {
                        return (
                            <Card
                                sx={{ maxWidth: 1200, mb: 2 }}
                                key={opportunity.id}
                            >
                                <CardHeader
                                    action={
                                        <OverlayTrigger
                                            trigger="click"
                                            placement="left"
                                            overlay={
                                                <Popover id="popover-positioned-left">
                                                    <ListItemButton
                                                        sx={{
                                                            color:
                                                                opportunity.is_open ===
                                                                    true
                                                                    ? "red"
                                                                    : "#0A8C4A",
                                                        }}
                                                        onClick={() =>
                                                            UpdateJobStatus(
                                                                opportunity
                                                            )
                                                        }
                                                    >
                                                        {opportunity.is_open ===
                                                            true
                                                            ? "Inactive Job"
                                                            : "Activate Job"}
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={() =>
                                                            onShowDetailModalJob(
                                                                opportunity
                                                            )
                                                        }
                                                    >
                                                        View Detail
                                                    </ListItemButton>
                                                </Popover>
                                            }
                                        >
                                            <Button>
                                                <Icon
                                                    fontSize="15"
                                                    sx={{
                                                        color: "#0A8C4A",
                                                        fontSize: 30,
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    more_horiz
                                                </Icon>
                                            </Button>
                                        </OverlayTrigger>
                                    }
                                    title={
                                        <Grid container>
                                            <Typography
                                                variant="h4"
                                                color="#070807"
                                                gutterBottom
                                                sx={{ fontWeight: 500 }}
                                            >
                                                {opportunity.title}
                                            </Typography>
                                            <Typography
                                                color={
                                                    opportunity.is_open === true
                                                        ? "#0A8C4A"
                                                        : "red"
                                                }
                                                sx={{
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    paddingLeft: 1,
                                                    paddingTop: 0.3,
                                                }}
                                            >
                                                {opportunity.is_open ===
                                                    true ? (
                                                    <li>Active</li>
                                                ) : (
                                                    <li>Inactive</li>
                                                )}
                                            </Typography>
                                        </Grid>
                                    }
                                    subheader={
                                        <>
                                            <Icon sx={{ paddingTop: 0.2 }}>
                                                work
                                            </Icon>{" "}
                                            Fulltime{" "}
                                            <Icon sx={{ paddingTop: 0.2 }}>
                                                location_on
                                            </Icon>{" "}
                                            {opportunity.Location.nama} ,
                                            Indonesia
                                            <Icon
                                                sx={{ paddingTop: 0.3, ml: 1 }}
                                            >
                                                people
                                            </Icon>{" "}
                                            {opportunity.CandidateCount}{" "}
                                            Candidate
                                        </>
                                    }
                                />
                                <CardContent>
                                    <Typography variant="h6" color="#0A8C4A">
                                        Unprocess Candidate :{" "}
                                        {opportunity.CountUnprocess} | Processed
                                        Candidate : {opportunity.CountProcess}
                                    </Typography>
                                </CardContent>
                                <CardActions disableSpacing>
                                    <Grid container>
                                        <Grid item lg={10}>
                                            {" "}
                                            <Typography variant="subtitle2">
                                                Created on{" "}
                                                {opportunity.created_date}{" "}
                                                &nbsp;&nbsp;&nbsp; Modified on{" "}
                                                {opportunity.updated_date}
                                            </Typography>
                                        </Grid>
                                        <Grid item lg={2}>
                                            <Link
                                                to={
                                                    `Admin/candidates/` +
                                                    opportunity.id
                                                }
                                            >
                                                <Button
                                                    variant="text"
                                                    onClick={goToTop}
                                                    color="primary"
                                                >
                                                    Manage Candidate
                                                    <Icon>arrow_forward</Icon>
                                                </Button>
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </CardActions>
                            </Card>
                        );
                    })
            ) : (
                <div style={{ height: "100vh" }}>
                    <p
                        style={{
                            display: "flex",
                            color: "red",
                            justifyContent: "center",
                        }}
                    >
                        No Data :(
                    </p>
                </div>
            )}
            <Pagination
                totalData={filteredJobs.length}
                currentPage={currentPage}
                onPageChange={({ page }) => changePage(page)}
                rowsPerPage={rowsPerPage}
                showFirstLastButton={true}
                // rowsPerPageOptions={[10, 30, 50, 60]}
                onRowsPerPageChange={setRowsPerPage}
                showResult={true}
                // showRowsPerPageOptions={true}
                showPageNumber={true}
            />
        </>
    );
}

export default CardJobs;
